<div id="iframe-container" class="iframe-max">
  <iframe id="module-messagerie"
          [src]="urlSafe"
          name="module-messagerie"
          frameBorder="0" style="border: 1px solid #ccc"
          title="" >
    <!--sandbox="allow-scripts allow-forms allow-popups"-->
  </iframe>
</div>
